import React, { useEffect, useMemo, useRef } from 'react';
import Button from 'src/Components/Button/Button';
import './SubscribePlan.css'
import { AuraProductLicenseType, IPaymentInfo, SuiteMapping } from 'src/Utils/Hooks/Payments/useGetPaymentProducts';
import { useTranslation } from 'react-i18next';
import { getCurrencySymbol } from 'src/Utils/CurrencySymbol/CurrencySymbol';
import { Annually, Monthly } from '../LicensePayment';

interface ILicensePaymentCard {
    selectedTab: string;
    title: AuraProductLicenseType;
    currency: string;
    userSeats: number;
    storageInGb: number;
    monthlypriceObj: IPaymentInfo;
    yearlypriceObj: IPaymentInfo;
    onPayClick: (priceId: string) => void;
}

const SubscribePlan: React.FC<ILicensePaymentCard> = ({
    selectedTab,
    title,
    currency,
    userSeats,
    storageInGb,
    monthlypriceObj,
    yearlypriceObj,
    onPayClick
}) => {
    const { t } = useTranslation();

    const annualPriceRef = useRef<number>(0);
    
    useEffect(() => {
        annualPriceRef.current = monthlypriceObj.price * 12;
    }, [monthlypriceObj.price]);

    const selectedPrice = useMemo(() => {
        return selectedTab === Monthly ? monthlypriceObj.price : yearlypriceObj.price;
    }, [selectedTab, monthlypriceObj.price, yearlypriceObj.price]);
    
    const billingPeriodText = useMemo(() => {
        return selectedTab === Monthly ? t('PerMonth') : t('PerYear');
    }, [selectedTab, t]);
    
    const selectedPriceId = useMemo(() => {
        return selectedTab === Monthly ? monthlypriceObj.priceId : yearlypriceObj.priceId;
    }, [selectedTab, monthlypriceObj.priceId, yearlypriceObj.priceId]);
    
    return (
        <div className={`col-sm-4 column`}>
            <div className="d-flex flex-column">
                <div className="subscribe-plan__header d-flex flex-column justify-content-center align-items-center p-3">
                    <span className="fw-bold">{t('AuraSoftwareSuite')}</span>
                    <span className="subscribe-plan__title">
                        {SuiteMapping[title]}
                    </span>
                </div>
                <div className="subscribe-plan__pricing d-flex flex-column justify-content-center align-items-center p-3">
                    {selectedTab === Annually && (
                        <del className="subscribe-plan__original-price">
                            {annualPriceRef.current}{getCurrencySymbol(currency)}
                        </del>
                    )}
                    <span className="subscribe-plan__price">
                        {selectedPrice}{getCurrencySymbol(currency)}
                    </span>
                    <span className="subscribe-plan__billing-period">
                        {billingPeriodText}
                    </span>
                </div>
                <div className="subscribe-plan__feature d-flex flex-column justify-content-center align-items-center p-3">
                    <span className="subscribe-plan__feature-value">{userSeats}</span>
                    <span className="subscribe-plan__feature-label">{t('FloatingSeats')}</span>
                </div>
                <div className="subscribe-plan__feature d-flex flex-column justify-content-center align-items-center p-3">
                    <span className="subscribe-plan__feature-value">{storageInGb} GB</span>
                    <span className="subscribe-plan__feature-label">{t('CloudStorage')}</span>
                </div>
                <div className="subscribe-plan__action d-flex flex-column justify-content-center align-items-center p-3">
                    <Button
                        width="100%"
                        text={t('ContinueWithSuite', {
                                suiteName: SuiteMapping[title]
                            })
                        }
                        onClick={() => onPayClick(selectedPriceId)}
                    />
                </div>
            </div>
        </div>
    );
};

export default SubscribePlan;
